import React from "react";
import { Button, Col, Row } from "antd";
import { useFlow, FLOWS } from "hook/draft/dialog/flow/useFlow";
import { IoChevronBackOutline } from "react-icons/io5";
import DetailCountDown from "./detail_countdown";
import DetailPreview from "./detail_preview";
import { useDialogLeave } from "hook/draft/dialog/action/useDialogLeave";
import DetailPreviewClone from "./detail_preview_clone";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const TaskDetail = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useFlow();
  const { loading, handleLeave } = useDialogLeave();
  const isFlow = flow === FLOWS.HAS_TASK;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBack = () => {
    return (
      <Button
        loading={loading}
        onClick={() =>
          handleLeave(
            "Số điểm mà bạn đã chỉnh sửa trong nhiệm vụ này sẽ không được tính",
          )
        }
        icon={
          <span className="anticon">
            <IoChevronBackOutline />
          </span>
        }
        danger
        type="link"
      >
        Rời khỏi công việc
      </Button>
    );
  };
  // -------------------------- MAIN ----------------------------
  if (!isFlow) return null;
  return (
    <Row gutter={[30, 30]}>
      <Col xl={24} lg={24} md={24} xs={24}>
        <DetailCountDown />
      </Col>
      <Col align="left" xl={24} lg={24} md={24} xs={24}>
        {renderBack()}
        <DetailPreviewClone />
      </Col>
    </Row>
  );
};
export default TaskDetail;
